import React from 'react';
import { connect } from 'react-redux';
import SelectV2 from '../../components/Common/Select_v2';

class Index extends React.PureComponent {
  onVariantsChange = this.onVariantsChange;

  onDurationChange(value) {
    const { onDurationChange } = this.props;
    onDurationChange(value);
  }

  render() {
    const {
      style,
      disabled,
      className,
      durations,
      resetToPrev,
      // selectedDuration,
      // defaultValue,
    } = this.props;
    const durationsArr = [];
    durationsArr.push(...durations.map(d => ({ value: d, label: `${d} days` })));
    durationsArr.sort((a, b) => a.value - b.value);
    return (
        <SelectV2
          style={style}
          name="durations"
          isClearable={false}
          isSearchable={false}
          disabled={disabled}
          className={className}
          options={durationsArr}
          onResetToPrev={resetToPrev}
          selectedValue={durationsArr[0]}
          placeholder="Select Duration ..."
          onChange={x => this.onDurationChange(x)}
          value={
            durationsArr[0].value === 0
              ? [{ value: 0, label: 'Please select options first' }] : durationsArr}
        />
    );
  }
}

export default connect(
  ({ product, order }) => ({
    variants: product.data.variants,
    variantSelected: order.variantSelected,
  }),
  dispatch => ({
    setVariantsQuantity: (a, b, c) => dispatch(setVariantsQuantity(a, b, c)),
  }),
)(Index);
